import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AppService } from "../services/app.service";

@Component({
  selector: "app-saved-cards",
  template: `
    <div
      style="display:flex; align-items:center; justify-content: space-between;"
    >
      <h1 mat-dialog-title style="margin-bottom:0px;">Cards</h1>

      <button mat-button (click)="addCard()">Add Card</button>
    </div>

    <div mat-dialog-content style="overflow:visible;">
      <div
        *ngFor="let card of data"
        style="display:flex; align-items:center; justify-content: space-between;"
      >
        <div
          style="border:1px solid #e5e5e5;border-radius:2%;margin-top:10px;width: 350px;padding:0 15px;"
        >
          <img
            src="assets/images/cards.png"
            style="padding:5px 10px;height:50px;"
          />

          <span style="font-size:14px;font-weight:800;"
            >Ending in {{ getLastFourDigit(card.lastFourDigit) }}</span
          >
        </div>

        <mat-radio-button
          [value]="card"
          (change)="handleChange($event)"
        ></mat-radio-button>
      </div>
    </div>

    <div mat-dialog-actions style="justify-content: end;">
      <button mat-button (click)="close()">Close</button>
      <button mat-button (click)="pay()">Pay</button>
    </div>
  `,
})
export class SavedCardsComponent {
  constructor(
    public dialogRef: MatDialogRef<SavedCardsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService
  ) {}

  userKey: any;
  userInfo: any;
  currentCard: any;
  appointmentRes: any;

  close() {
    this.dialogRef.close();
  }

  getLastFourDigit(cardNumber: string) {
    let splitted = cardNumber.split("-");

    return splitted[3];
  }

  addCard() {
    this.appService.addCard(this.userKey, this.userInfo).subscribe(
      (res: any) => {
        if (res.data) {
          window.location.href = res.data.addCardUrl;
        }
      },

      (err) => {}
    );
  }

  handleChange(event) {
    this.currentCard = event.value;
    console.log("currentCard............", this.currentCard);
  }

  pay() {
    let request = {
      paymentType: "Credit",
      applicationReturnUrl: this.appService.paymentReturnUrl,
      paymentMode: "CARD_NOT_PRESENT",
      merchantTokenId: this.currentCard.merchantTokenId,
      appSource: "WEB",
      loggedInUser: { userKey: this.userKey },
      transactionType: "Deposit",
      amount: this.appointmentRes.depositAmount,
    };

    this.appService
      .getPaymentLink(request, this.appointmentRes.estimateNumber)
      .subscribe(
        (res: any) => {
          if (res.data) {
            window.location.href = res.data.applicationReturnUrl;
          }
        },

        (err: any) => {}
      );
  }
}
